import { render } from "./SwitchComponent.vue?vue&type=template&id=7e779d2f&scoped=true"
import script from "./SwitchComponent.vue?vue&type=script&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&lang=js"

import "./SwitchComponent.vue?vue&type=style&index=0&id=7e779d2f&scoped=true&lang=scss"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e779d2f"]])

export default __exports__